//import required libraries
import './cookies';
import './shared';
const $ = require('jquery');


//setup event listeners and initialize function boxes
$(document).ready(function() {
    //set initial function box in carousel
    initCarousel();
    //change status of active function box in carousel
    $('#functions-carousel').on('slid.bs.carousel', function(slideEvent) {
        setActiveCarousel(slideEvent);
        let previews = $('.preview');
        previews[slideEvent.to].classList.remove("sliding");
        if (slideEvent.to < slideEvent.from || (slideEvent.to == 5 && slideEvent.from == 0)) {
            previews[slideEvent.from].classList.remove("active-preview");
            previews[slideEvent.from].classList.add("sliding");
            previews[slideEvent.to].classList.add("active-preview");
        }
    });

    $('.years-data').each(function () {
        let currentYear = new Date().getFullYear();
        $(this).text(currentYear - 2007);
    });

    //change carousel image and preview box
    $('#functions-carousel').on('slide.bs.carousel', function(slideEvent) {
        var id = slideEvent.relatedTarget.id - 1;
        let previews = $('.preview');

        if (slideEvent.to > slideEvent.from || (slideEvent.to == 0 && slideEvent.from == 5)) {
            previews[slideEvent.from].classList.remove("active-preview");
            previews[slideEvent.from].classList.add("sliding");
            previews[slideEvent.to].classList.add("active-preview");
        }

        setInactiveCarousel(slideEvent);

        let smallImagesList = $('.sm-images .image-holder');
        id %= smallImagesList.length;
        for (let index = 0; index < smallImagesList.length; index++) {
            if (index == id) {
                smallImagesList[index].classList.remove('d-none');
                smallImagesList[index].classList.add('d-block');
            }
            if (index == slideEvent.from) {
                if (smallImagesList[index].classList.contains('d-none')) {
                    continue;
                }
                smallImagesList[index].classList.add('d-none');
                smallImagesList[index].classList.remove('d-block');
            }

        }
    });

    function scrollToSettings(location) {
        return /cookie-settings/gi.test(location);
    }

    if (scrollToSettings(window.location.href)) {
        setTimeout(() => {
            $('.cookie-settings')[0].scrollIntoView();
        }, 10);
    }

    //change status of last/currently visited function box
    var largeFunctionsList = document.getElementsByClassName('functions');
    for (var i = 0; i < largeFunctionsList.length; i++)
        largeFunctionsList[i].addEventListener('mouseenter', setActive, false);
});


//initialize carousel
function initCarousel() {
    let activeElement = $('.carousel-item.active');
    if (activeElement.length) {
        let innerDivActive = activeElement[0].childNodes;
        let parallelogram = document.createElement("div");
        parallelogram.classList.add("parallelogram");
        innerDivActive[1].appendChild(parallelogram);
    }
}

//set normal status to inactive carousel function box
function setInactiveCarousel(slideEvent) {
    let elements = $('.carousel-item');
    let previousActiveElement = elements[slideEvent.from];
    let previousActiveInnerDiv = previousActiveElement.childNodes;
    if (previousActiveInnerDiv[1].childNodes[3] != null) previousActiveInnerDiv[1].childNodes[3].remove();
}


//set active status to inactive carousel function box
function setActiveCarousel(slideEvent) {
    let newActiveInnerDiv = slideEvent.relatedTarget.childNodes;
    let parallelogram = document.createElement("div");
    parallelogram.classList.add("parallelogram");
    newActiveInnerDiv[1].appendChild(parallelogram);
}

let lastIndex = "1";
let imagesList = document.getElementsByClassName("image-holder");

function setActive(event) {
    let target = event.target ? event.target : event.srcElement;
    deselect(lastIndex);
    let element = target.children;
    let parallelogram = document.createElement("div");
    element[0].classList.add("fbactive");
    parallelogram.classList.add("parallelogram");
    element[0].appendChild(parallelogram);
    imagesList[parseInt(target.id) - 1].classList.remove("d-none");
    imagesList[parseInt(target.id) - 1].classList.add("d-block");
    lastIndex = target.id;
}

function setInActive(target, id) {
    let element = target.children;
    element[0].classList.remove("fbactive");
    element[0].children[1].remove();
    imagesList[parseInt(id) - 1].classList.remove("d-block");
    imagesList[parseInt(id) - 1].classList.add("d-none");
}

function deselect(id) {
    let target = document.getElementById(id);
    setInActive(target, id);
}


// ============================================================
// References - load more
// ============================================================
$(function () {
    var $btn = $('#loadMoreReferences');
    if ($btn.length === 0) return;

    var step = 3;
    var initial = 3;

    var $gridItemsAll = $('.references-grid__item').detach();
    var $carouselItemsAll = $('#references-carousel .carousel-item').detach();
    var total = $gridItemsAll.length;

    var $grid = $('.references-grid');
    var $carousel = $('#references-carousel');
    var $carouselInner = $carousel.find('.carousel-inner');
    var $indicators = $carousel.find('.carousel-indicators');

    var visible = 0;
    var isSliding = false;

    $carousel.on('slide.bs.carousel', function () {
        isSliding = true;
    });
    $carousel.on('slid.bs.carousel', function () {
        isSliding = false;
    });

    // Append items to desktop grid only
    function appendGridItems(fromIndex, toIndex) {
        for (var i = fromIndex; i < toIndex; i++) {
            $grid.append($gridItemsAll.eq(i).clone());
        }
    }

    // Render all items into mobile carousel + indicators (run once at startup)
    function renderCarousel() {
        for (var j = 0; j < total; j++) {
            var $clone = $carouselItemsAll.eq(j).clone();
            $clone.removeClass('active');
            if (j === 0) $clone.addClass('active');
            $carouselInner.append($clone);

            var $li = $('<li>')
                .attr('data-target', '#references-carousel')
                .attr('data-slide-to', j);
            if (j === 0) $li.addClass('active');
            $indicators.append($li);
        }
    }

    function doLoadMore() {
        if (visible >= total) return;

        var firstNewIndex = visible;
        var nextVisible = Math.min(visible + step, total);

        appendGridItems(visible, nextVisible);
        visible = nextVisible;

        if (visible >= total) {
            $btn.addClass('is-hidden');
        }

        // Smooth scroll na prvu novu kartu (desktop only)
        if (window.matchMedia('(min-width: 1200px)').matches) {
            var firstNew = $grid.find('.references-grid__item').eq(firstNewIndex);
            if (firstNew.length) {
                var navbarEl = document.getElementById('navbar');
                var navbarHeight = navbarEl ? navbarEl.offsetHeight : 80;
                var top = firstNew[0].getBoundingClientRect().top + window.pageYOffset - navbarHeight - 20;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        }
    }

    // Initial render
    visible = Math.min(initial, total);
    appendGridItems(0, visible);
    renderCarousel();
    $carousel.carousel({ interval: false });

    if (visible >= total) {
        $btn.addClass('is-hidden');
    }

    $btn.on('click', function () {
        if (visible >= total) return;

        if (isSliding) {
            $carousel.one('slid.bs.carousel', function () {
                doLoadMore();
            });
        } else {
            doLoadMore();
        }
    });
});